import cmfConfig from './config/cmf_config';
import getCmfApiUrl from './helpers/getCmfApiUrl';

export interface effectResultInterface {
    age: number,
    category: null,
    effect_id: string,
    output_file: string,
    success: number
}

/**
 * Uploads an image to the API.
 * @param {string} body - The body data for the fetch request.
 * @returns {promise}
 */
const applyEffects = async (body: string | FormData) => {
    const url = getCmfApiUrl();

    const config = {
        ...cmfConfig,
        method: 'POST',
        body
    };

    if (process.env.REACT_APP_USE_API_MOCK === 'true') {
        config.headers['x-mock-response-name'] = 'Apply Effects - 200';
    }

    return fetch(url, config);
};

export default applyEffects;
